import React from 'react';

import { Formik } from 'formik';
import * as Yup from 'yup';

import BudgetAttachmentFields from '../BudgetAttachmentFields';

import ModalFooter from 'CommonComponents/ModalFooter';
import TextareaFormField from 'CommonComponents/TextareaFormField';
import TextFormField from 'CommonComponents/TextFormField';

const GeneralOpportunitySchema = Yup.object().shape({
    name: Yup.string().required($t('This value is required')),
    description: Yup.string().required($t('This value is required')),
    specific: Yup.bool(),
    amount: Yup.number().nullable().min(0, $t('Amount must be zero or greater')),
    budget_department_key: Yup.string().nullable(),
    budget_department_type: Yup.string().nullable(),
    budget_department_id: Yup.string().nullable(),
    budget_line_type: Yup.string().nullable(),
    budget_line_id: Yup.string().nullable(),
});

export default function GeneralOpportunityForm(props) {
    return (
        <Formik
            enableReinitialize
            initialValues={{
                name: props.opportunity?.name || '',
                description: props.opportunity?.description || '',
                specific: !!(props.opportunity?.specific || props.opportunity?.afc),
                amount: props.opportunity?.amount || 0,
                budget_department_key:
                    props.opportunity?.budget_department_type && props.opportunity?.budget_department_id
                        ? `${props.opportunity.budget_department_type}::${props.opportunity.budget_department_id}`
                        : '',
                budget_department_type: props.opportunity?.budget_department_type || '',
                budget_department_id: props.opportunity?.budget_department_id || '',
                budget_line_id: props.opportunity?.budget_line_id || null,
                budget_line_type: props.opportunity?.budget_line_type || null,
            }}
            validationSchema={GeneralOpportunitySchema}
            onSubmit={(values, actions) => {
                if (props.opportunity?.id) {
                    const updateUrl = props.updateUrl.replace('GENERAL_OPPORTUNITY_ID', props.opportunity.id);

                    axios
                        .put(updateUrl, values)
                        .then((res) => {
                            actions.resetForm();
                            props.onSuccess();
                        })
                        .catch((e) => {
                            e?.response?.data?.errors && actions.setErrors(e.response.data.errors);
                        })
                        .finally(() => {
                            actions.setSubmitting(false);
                        });
                } else {
                    axios
                        .post(props.storeUrl, values)
                        .then((res) => {
                            actions.resetForm();
                            props.onSuccess();
                        })
                        .catch((e) => {
                            e?.response?.data?.errors && actions.setErrors(e?.response?.data?.errors);
                        })
                        .finally(() => {
                            actions.setSubmitting(false);
                        });
                }
            }}
        >
            {({ values, errors, touched, isSubmitting, handleSubmit, setFieldValue }) => {
                return (
                    <>
                        <div className="tw-grid tw-grid-cols-1">
                            <TextFormField label={$t('Name')} required={true} type="text" name="name" placeholder={$t('Enter opportunity name')} />
                        </div>

                        <div className="tw-grid tw-grid-cols-1">
                            <TextareaFormField
                                label={$t('Description')}
                                as="textarea"
                                type="text"
                                name="description"
                                placeholder={$t("Enter opportunity's detailed description")}
                            />
                        </div>

                        <BudgetAttachmentFields
                            departmentsOptions={props.departmentsOptions}
                            fetchBudgetLinesUrl={props.fetchBudgetLinesUrl}
                            values={values}
                            setFieldValue={setFieldValue}
                            errors={errors}
                            touched={touched}
                            disabled={isSubmitting}
                            afcField="specific"
                            afcLabel={$t('Include in AFC')}
                            showAfcWhenCentral
                            departmentAside={
                                <div className="tw-flex tw-flex-col tw-space-y-1.5">
                                    <TextFormField label={$t('Amount')} type="number" name="amount"></TextFormField>
                                </div>
                            }
                        />

                        <ModalFooter
                            cancelButtonText={$t('Cancel')}
                            primaryButtonText={$t('Save')}
                            onCancel={props.onCancel}
                            onDelete={props.onDelete}
                            handleSubmit={handleSubmit}
                            isSubmitting={isSubmitting}
                            submitButtonVariant={'primary'}
                        ></ModalFooter>
                    </>
                );
            }}
        </Formik>
    );
}
